"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCanvaIsSupportedForFilter = exports.getCanvaInitStatus = exports.getCanvaDownloadStatus = void 0;

var _reselect = require("reselect");

var getCanva = function getCanva(state) {
  return state.canva;
};

var getFilter = function getFilter(state) {
  return state.filter;
};

var getCanvaDownloadStatus = (0, _reselect.createSelector)([getCanva], function (canva) {
  return canva.get('downloadStatus');
});
exports.getCanvaDownloadStatus = getCanvaDownloadStatus;
var getCanvaInitStatus = (0, _reselect.createSelector)([getCanva], function (canva) {
  return canva.get('initStatus');
});
exports.getCanvaInitStatus = getCanvaInitStatus;
var getCanvaIsSupportedForFilter = (0, _reselect.createSelector)([getFilter], function (filter) {
  if (!filter) {
    return true;
  }

  var extensions = filter.get('extensions');
  var filterType = filter.get('filterType');
  var isSupportedForFilter;

  switch (filterType) {
    case 'NONE':
      isSupportedForFilter = true;
      break;

    case 'SUPPORTED':
      isSupportedForFilter = Boolean(extensions.includes('png'));
      break;

    case 'UNSUPPORTED':
      isSupportedForFilter = !extensions.includes('png');
      break;

    default:
      isSupportedForFilter = true;
      break;
  }

  return isSupportedForFilter;
});
exports.getCanvaIsSupportedForFilter = getCanvaIsSupportedForFilter;